import { render, staticRenderFns } from "./DataRecommend.vue?vue&type=template&id=579b0d14&scoped=true"
import script from "./DataRecommend.vue?vue&type=script&lang=js"
export * from "./DataRecommend.vue?vue&type=script&lang=js"
import style0 from "./DataRecommend.vue?vue&type=style&index=0&id=579b0d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b0d14",
  null
  
)

export default component.exports